import { Observable } from 'rxjs';
import { getTranslation as t } from '../lib/i18n';
import { ipBlockChecker } from './system-error';

const errorCheckers = [ipBlockChecker];

export function getMessageFromResponse(payload, defaultMessage = t('请稍后再试')) {
	try {
		return payload.response.message;
	} catch (e) {
		console.log(e);
	}

	return defaultMessage;
}

export function createErrorActions(error) {
	const actions = [];
	const errorCode = error?.response?.code;

	if (errorCode) {
		errorCheckers.forEach(errorChecker => {
			const action = errorChecker(errorCode);

			if (typeof action === 'object' && action.type) {
				actions.push(action);
			}
		});
	}

	if (!actions.length) {
		actions.push({
			type: 'AJAX_ERROR',
			error,
		});
	}

	return actions;
}

export function catchErrorForEpics(error, ...callbacks) {
	const errorCode = error?.response?.code;

	if (errorCode) {
		const ipBlockAction = ipBlockChecker(errorCode);

		if (ipBlockAction) {
			return [ipBlockAction];
		}
	}

	return [
		...createErrorActions(error),
		...catchErrorMessageForEpics(error, ...callbacks),
	];
}

const PARSE_FAIL_RESPONSE = {
	code: 'unknown',
	type: 'unknown',
	message: 'parse error',
};

function getParseFailRes(error = {}) {
	return {
		...error,
		response: PARSE_FAIL_RESPONSE,
	};
}

export function catchBlobErrorForEpics(error, ...callbacks) {
	const next = (observer, decodedError) => {
		const errorActions = catchErrorForEpics(decodedError, ...callbacks);

		errorActions.forEach(action => observer.next(action));

		observer.complete();
	};

	return new Observable(observer => {
		if (
			!error.xhr ||
			!error.xhr.response ||
			error.xhr.response instanceof Blob === false
		) {
			next(observer, getParseFailRes(error));
			return;
		}

		const reader = new FileReader();

		reader.onload = () => {
			try {
				const jsonResponse = JSON.parse(reader.result);
				const decodedError = {
					...error,
					response: jsonResponse,
				};

				next(observer, decodedError);
			} catch (_) {
				next(observer, getParseFailRes(error));
			}
		};

		reader.onerror = () => {
			next(observer, getParseFailRes(error));
		};

		reader.readAsText(error.xhr.response);
	});
}

export function catchErrorMessageForEpics(error, ...callbacks) {
	let errorMessage = getMessageFromResponse(error, t('请稍后再试'));

	return callbacks.map(callback => callback(error, errorMessage));
}
